import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {IMonster, MONSTER_MOVE_ACTIONS} from "../server/IData";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import { Sound } from "../sound/Sound";

export class AllHighlightRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.isMonsterMove() && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            monsters: IMonster[] = Game.model.gameData.monsters;

        monsters.forEach((monster: IMonster) => {
            if (!monster.path || monster.path.length <= 1) {
                return;
            }

            const monsterSymbol: MonsterSymbol = Game.reelsView.reelModels[monster.path[0].x].getMonsterSymbolAt(monster.symbol);
            if (monsterSymbol && Game.MONSTER_SYMBOLS.includes(monsterSymbol.name)) {
                monsterSymbol.animation.autoUpdate = true;
                monsterSymbol.animation.state.setAnimation(0, MONSTER_MOVE_ACTIONS.IDLE, true).mixDuration = 0.2;

                tl.add(monsterSymbol.highlightMonsterPath(monster.path), 0.2);
            }
        })

        tl.add(()=>{
            Game.soundPlayer.playSound(Sound.LOOT_HIGHLIGHT, 1);
        }, 0);

        tl.to(this, {
            duration: 0.1
        });
    }
}